import Menu from "../../../components/Menu"
import RoundyContainer from 'components/RoundyContainer';
import DisclosureAgreement from 'components/StraightThroughVehicleComp/DisclosureAgreement/DisclosureAgreement';
import { RemoveVehicleContext, RemoveVehicleContextComp } from 'components/StraightThroughVehicleComp/RemoveVehicleContext/RemoveVehicleContext';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { storageData } from 'services/Services';
import VehicleProgressBreadCrumb from "components/StraightThroughVehicleComp/VehicleProgressBreadCrumb";
import RemoveVehicleMain from "components/StraightThroughVehicleComp/VehicleMain_Remove/RemoveVehicleMain";

const RemoveVehicle = (props) => {
    const navigate = useNavigate()
    const { userData, setUserData } = props.user
    const [showModal, setShowModal] = useState(true);
    const websiteMaintenance = JSON.parse(storageData?.getItem("websiteMaintenance"));

    const handleClose = () => {
        setShowModal(false);
        userData["disclosureModal"] = true
        storageData.setItem("userData", JSON.stringify(userData));
    }

    useEffect(() => {
        window.scrollTo(0, 0)

        // Redirect to maintenance page if maintenance is on for Remove Vehicle Endorsement
        if (websiteMaintenance?.status?.Result == "Active" && websiteMaintenance?.status?.Pages?.includes("EndorsementRemoveVehicle")) {
            navigate("/maintenance")
            return
        }
    }, [])

    return (
        <>
            <RemoveVehicleContextComp>
                <Menu Title={"REMOVE VEHICLE"} FirstName={userData.firstName} userData={userData} />
                <VehicleProgressBreadCrumb requestContext={RemoveVehicleContext} endorsementType={"RemoveVehicle"} />
                <RoundyContainer Content={RemoveVehicleMain} NoRoundy
                    params={{
                        storedData: { ...props.storedData },
                        setStoredData: props.setStoredData,
                        setUserData: setUserData
                    }}
                />

                {!userData?.disclosureModal &&
                    <DisclosureAgreement
                        showModal={showModal}
                        handleClose={handleClose}
                        title="DISCLOSURE AGREEMENT"
                        policyState={userData.state}
                        requestType="Remove Vehicle"
                    />
                }
            </RemoveVehicleContextComp>
        </>
    )
}

export default RemoveVehicle